import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default function toggle(ComposedComponent) {
  return class Toggle extends Component {
    static propTypes = { active: PropTypes.bool };

    constructor(props) {
      super(props);
      this.state = { active: props.active || false};
    }

    setActive = (active: bool): void => this.setState({ active });
    toggleActive = (): void => this.setState({ active: !this.state.active });

    render() {
      return (
        <ComposedComponent
          { ...this.state }
          { ...this.props }
          setActive = { this.setActive }
          toggleActive = { this.toggleActive }
        />
      );
    }
  };
}
